<template>
    <div>
        <h1>Objednávka kurzu</h1>
        <ssv-order-header-woodwork-certification/>
        <ssv-order-billing-information-container required ref="billingInformation"/>
        <ssv-order-contact-information-container required extended mkt-communication same-participant ref="contactInformation"/>
        <ssv-order-participant-container ref="participant"/>
        <ssv-order-note/>
        <ssv-order-price-container/>
    </div>
</template>

<script>
    import SsvOrderBillingInformationContainer from '../billing-information/BillingInformationContainer';
    import SsvOrderContactInformationContainer from '../contact-information/ContactInformationContainer';
    import SsvOrderPriceContainer from '../price/PriceContainer';
    import SsvOrderBuildingCertificationContainer from '../building-certification/BuildingCertificationContainer';
    import SsvOrderNote from '../parameters/OrderNote';
    import SsvOrderParticipantContainer from '../participant/ParticipantContainer';
    import SsvOrderHeaderWoodworkCertification from '../header/HeaderWoodworkCertification';

    export default {
        name:       'SsvOrderOnlineWoodworkCertification',
        components: {
            SsvOrderHeaderWoodworkCertification,
            SsvOrderParticipantContainer,
            SsvOrderNote,
            SsvOrderBuildingCertificationContainer,
            SsvOrderPriceContainer,
            SsvOrderContactInformationContainer,
            SsvOrderBillingInformationContainer
        },
        methods:    {
            validate() {
                this.$refs.billingInformation.validate();
                this.$refs.participant.validate();
                this.$refs.contactInformation.validate();
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/ssv-order/order/OnlineWoodworkCertification.vue